import { useState } from 'react';
import { Button } from '@mui/material';
import { Column, EditDrawer, HorizontalFormInput } from '.';

interface EditAdminButtonProps {
  currentEntity: any;
  currentLevel: string;
  onEdit: (values: any) => void;
}

const EditAdminButton: React.FC<EditAdminButtonProps> = ({
  currentEntity,
  currentLevel,
  onEdit,
}) => {
  const [editDrawer, setEditDrawer] = useState(false);

  return (
    <>
      <Button
        onClick={() => {
          setEditDrawer(true);
        }}
        sx={{
          padding: '5px 30px',
          typography: { fontSize: 12 },
          height: '30px',
          border: '1px solid #b6c0c4',
        }}
        color='info'>
        Edit
      </Button>
      <EditDrawer
        title={`Edit ${currentLevel}`}
        drawerOpen={editDrawer}
        setDrawerOpen={setEditDrawer}
        onSubmit={onEdit}>
        <Column
          style={{
            width: '90%',
          }}>
          <HorizontalFormInput<any>
            fieldName='name'
            label='Name'
            initialValue={currentEntity.name}
            labelStyle={{ flex: '2 0 10px', marginTop: '10px' }}
            inputStyle={{ flex: '3 0 10px' }}
            textSize='small'
            rightAlignedKey
            required
          />
        </Column>
      </EditDrawer>
    </>
  );
};

export default EditAdminButton;
